import { render, staticRenderFns } from "./KpiTargetNew.vue?vue&type=template&id=b534fc72&"
import script from "./KpiTargetNew.vue?vue&type=script&lang=js&"
export * from "./KpiTargetNew.vue?vue&type=script&lang=js&"
import style0 from "./KpiTargetNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports